<p-toast></p-toast>
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
<section class="card">
    <p-table [value]="distribuidorPage" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th colspan="7" class="text-center"> Distribuidores </th>
            </tr>
            <tr>
                <th>RFC</th>
                <th>Razon Social</th>
                <th>Nombre del contacto</th>
                <th>Correo del contacto</th>
                <th colspan="2" style="text-align: center;">Acciones</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-distribuidor>
            <tr>

                <td><span>{{distribuidor.rfc}}</span></td>
                <td><span>{{distribuidor.razon_social}}</span></td>
                <td><span>{{distribuidor.nombre_contacto | uppercase}}</span></td>
                <td><span>{{distribuidor.correo_contacto}}</span></td>
                <td><a href="javascript:void(0)" (click)="confirmacion(distribuidor)">
                        <li class="pi pi-pause"></li>
                    </a></td>
                <td><a href="javascript:void(0)" (click)="mensaje(distribuidor)">
                        <li class="pi pi-user-edit"></li>
                    </a></td>

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="7" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron distribuidores</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"></p-paginator>
    </div>
</section>